exports = module.exports = require("../../../../../../../../../../../usr/lib/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".besidaMob-recommendation__recommendation--3tMaP{background:#fff;border-radius:2px;margin:0 15px 15px 10px;padding:10px}.besidaMob-recommendation__list--2ktCE{list-style-type:none;margin:0;padding:5px}.besidaMob-recommendation__item--32y3y{padding:3px 0 3px 10px}.besidaMob-recommendation__header--2SN6o{font-weight:700}", ""]);

// exports
exports.locals = {
	"recommendation": "besidaMob-recommendation__recommendation--3tMaP",
	"list": "besidaMob-recommendation__list--2ktCE",
	"item": "besidaMob-recommendation__item--32y3y",
	"header": "besidaMob-recommendation__header--2SN6o"
};